// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import RemindOutlineSvg from '@rsuite/icon-font/lib/status/RemindOutline';
var RemindOutline = createSvgIcon({
  as: RemindOutlineSvg,
  ariaLabel: 'remind outline',
  category: 'status',
  displayName: 'RemindOutline'
});
export default RemindOutline;